(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@skype/tsregistrar", [], factory);
	else if(typeof exports === 'object')
		exports["@skype/tsregistrar"] = factory();
	else
		root["@skype/tsregistrar"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition